import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { AutomationWizardForm } from '../../containers/automation-wizard-form'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AutomationShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { automationOperations } from '../../../../state/ducks/automations'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'

class AutomationEditorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getAutomation(this.props.match.params.automation_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_AUTOMATIONS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Automations
                    </NavLink>
                </li>
                <li>Edit Automation</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.automation.name}
                        subTitle={'Edit Automation'}
                        paths={this.renderHeaderPaths}
                    />
                    <AutomationWizardForm
                        automation={this.props.automation}
                        isEditor={true}
                    />
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
AutomationEditorPage.propTypes = {
  automation: AutomationShape,
  getAutomationErrorResponse: PropTypes.object
}

// Set defaultProps
AutomationEditorPage.defaultProps = {
  automation: {},
  getAutomationErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  automation: state.automations.getAutomationReducer.data,
  isLoading: state.automations.getAutomationReducer.loading,
  getAutomationErrorResponse: state.automations.getAutomationReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getAutomation: automationOperations.get
}

// Export Class
const _AutomationEditorPage = connect(mapStateToProps, mapDispatchToProps)(AutomationEditorPage)
export { _AutomationEditorPage as AutomationEditorPage }
